<div class="modal-container">
  <div class="edit-fac-container">
    <div class="inner-contant">
      <div class="edit-header">
        <div class="hearth-title">
          <svg (click)="closeModal.emit()" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.828 12.778H20V14.778H7.828L13.192 20.142L11.778 21.556L4 13.778L11.778 6L13.192 7.414L7.828 12.778Z" fill="black"/>
          </svg>            
          <span class="card-title">Produtos ofertados</span>
        </div>           
      </div>  
      <div class="list-container">
        <div class="list-item" *ngFor="let item of list">
          <p class="date">{{item.offer_date}}</p>
          <div class="item-container" *ngFor="let product of item.products">
            <div class="item-top-info">              
              <div [innerHTML]="product.description"></div>
            </div>
            <div class="address-info" *ngIf="product.address">
              <span>
                {{product.address.street}}, {{product.address.number}}, {{product.address.neighborhood}},
                 {{product.address.city}}-{{product.address.state}}, CEP: {{product.address.zip_code}}
              </span>
            </div>
            <div class="link-row">
              <p>{{product.offer_time}} - </p>
              <a *ngIf="featureProductSheet" class="link" target="_blank" href="/produtos/ficha/{{product.sku}}">&nbsp;Ficha do imóvel</a>
              <a *ngIf="!featureProductSheet" class="link" target="_blank" href="{{product.url}}">&nbsp;Ficha do imóvel</a>
            </div>       
          </div>
        </div>   
      </div>    
    </div>  
  </div>
</div>  
